import script from "./AppLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./AppLogin.vue?vue&type=script&setup=true&lang=js"

import "./AppLogin.vue?vue&type=style&index=0&id=226225fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-226225fa"]])

export default __exports__